export default __webpack_public_path__ + "static/media/gstr_step_1.930bfad9.png";